import { embedDashboard } from '@superset-ui/embedded-sdk'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { getToken } from 'utils/storage.utils'
import { useLocation } from "react-router-dom";
import { VStack, Box, Flex, Button, Icon } from '@chakra-ui/react'
import { BiArrowBack  } from 'react-icons/bi'
import { Card } from 'components/card/card'



async function getSuperSetToken(dashboardId) {
 
  const woaToken = getToken();

  const woa_header = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + woaToken,
    },
  }

await axios.get('api/application-prop/super-set/token?dashboardId='+ dashboardId, woa_header).then(dt => {
    //console.log(dt.data['token'])
    embedDashboard({
      id: dt.data['dashboardId'], // given by the Superset embedding UI
      supersetDomain: dt.data['superSetUrl'],
      mountPoint: document.getElementById('superset-container') as HTMLElement, // html element in which iframe render
      fetchGuestToken: () => dt.data['token'],
      dashboardUiConfig: { hideTitle: true },
    })
  })

  var iframe = document.querySelector('iframe')
  if (iframe) {
    iframe.style.width = '100%' // Set the width as needed
    iframe.style.minHeight = '60vw' // Set the height as needed
  }
}

const Reports = () => {
  const params = new URLSearchParams( useLocation().search );
  const dashboardId = params.get("dashboardId");
  getSuperSetToken(dashboardId)
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/reportsDashboard');
  };
  return (
    <div className="App">
      <VStack alignItems="start" minH="calc(100vh - 160px)" pb="2">
        <Card
          w="100%"
          py="14px"
          px="14px"
          boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
        >
          <Flex w="100%" mb="14px" alignItems={'center'}>
            <Button onClick={handleBackClick} colorScheme="brand" fontSize="14px" minW={'140px'} mb={'15px'}>
              <Icon as={BiArrowBack } fontSize="18px" mr={2} />
                Back
            </Button>
          </Flex>

          <Box w="100%" >
          <div id="superset-container"></div>
          </Box>
        </Card>
    </VStack>
    </div>
  )
}


export default Reports
